const ELLIPSIS = '…';

export const truncateBreadcrumbLabel = (label: string, maxChars?: number) => {
  if (!maxChars || label.length <= maxChars) {
    return label;
  }

  return `${label.slice(0, maxChars).trimEnd()}${ELLIPSIS}`;
};

export const getBreadcrumbTitle = (label: string, displayLabel: string) =>
  displayLabel === label ? undefined : label;
